// extracted by mini-css-extract-plugin
export var allFeaturesTittle = "style-module--allFeaturesTittle--5a9bb";
export var available = "style-module--available--03f26";
export var disabled = "style-module--disabled--231d2";
export var featureInfo = "style-module--featureInfo--d5104";
export var featureInfoMobile = "style-module--featureInfoMobile--3b392";
export var featureOption = "style-module--featureOption--ca365";
export var featureRow = "style-module--featureRow--c9de2";
export var featureRowFourColumns = "style-module--featureRowFourColumns--f47de";
export var featureRowTwoColumns = "style-module--featureRowTwoColumns--dc8b5";
export var featureWrapper = "style-module--featureWrapper--96e4d";
export var groupTitle = "style-module--groupTitle--39f15";
export var listTitlesMobile = "style-module--listTitlesMobile--4779d";
export var metadesc = "style-module--metadesc--bbb42";
export var mobileBulb = "style-module--mobileBulb--d13cf";
export var moduleValueAccent = "style-module--moduleValueAccent--55ce3";
export var moduleValueText = "style-module--moduleValueText--b85f6";
export var moduleValueWrapper = "style-module--moduleValueWrapper--5a7b6";
export var oneFeaturesGroup = "style-module--oneFeaturesGroup--c4bad";
export var withTooltip = "style-module--withTooltip--15417";
export var wrapperFeatures = "style-module--wrapperFeatures--25a05";